import {
  ThemeOverride,
  extendTheme,
  withDefaultColorScheme,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";

import { AppThemeProvider } from "@picovico/ui";
import Link from "next/link";
import { breakpoints } from "./breakpoints";

export const WebThemeProvider = ({
  children,
  theme,
}: {
  children: React.ReactNode;
  theme?: Record<string, unknown>;
}) => {
  const [appTheme, setAppTheme] = useState({});
  useEffect(() => {
    theme &&
      setAppTheme(
        extendTheme(
          {...theme as ThemeOverride, breakpoints},
          // breakpoints,
          withDefaultColorScheme({
            colorScheme: "primary",
            components: [
              "Button",
              "Input",
              "Select",
              "Checkbox",
              "Radio",
              "Tabs",
            ],
          }),
        ),
      );
  }, [theme]);

  return appTheme ? (
    <AppThemeProvider
      theme={{
        ...appTheme,
      }}
      toastOptions={{
        defaultOptions: {
          position: "top-right",
          duration: 5000,
        },
      }}
      link={Link}
    >
      {children}
    </AppThemeProvider>
  ) : null;
};
